/**
 * Returns true if the browser is solid
 * @returns {boolean}
 */
export function isSupportedBrowser(): boolean {
    const isChrome = !!window['chrome'];
    const isEdgeChromium =
        isChrome && navigator.userAgent.indexOf('Edg') !== -1;
    const isFirefox = navigator.userAgent.indexOf('Firefox') !== -1;
    const isChromeBrowser = navigator.userAgent.indexOf('Chrome') !== -1;

    return isChromeBrowser || isEdgeChromium || isFirefox;
}
